import React from 'react';
import NudosSelectButton from '../../../../../../components/NudosComponents/NudosSelectButton/NudosSelectButton';
import './ProductSelectorHeader.scss';

interface ProductSelectorHeaderProps {
  headerTitle: string;
  hasTemporaryStorage?: boolean;
  selectAll: boolean;
  handleSelectAllChange: () => void;
  displayTemporaryStorageAlert?: boolean;
}

const ProductSelectorHeader: React.FC<ProductSelectorHeaderProps> = ({
  headerTitle,
  hasTemporaryStorage,
  selectAll,
  handleSelectAllChange,
  displayTemporaryStorageAlert
}) => {
  return (
    <>
      <div className="headerContainer">
        <div className="headerTitle">{headerTitle}</div>
        {!hasTemporaryStorage && (
          <div className="selectMasiveProductsContainer" onClick={handleSelectAllChange}>
            <NudosSelectButton
              isButtonActive={selectAll}
              handleClickButton={handleSelectAllChange}
              iconName="xmark"
              colorPalette="black"
              componentSize="small"
            />
            <span>Actualizar el estado de todas las unidades de todos los productos de este envío</span>
          </div>
        )}
      </div>

      {displayTemporaryStorageAlert && (
        <div className="subtitle">
          Para cambiar el estado a en bodega, primero debes agregar los seriales de cada unidad del producto.
        </div>
      )}
    </>
  );
};

export default ProductSelectorHeader;
